import { render, staticRenderFns } from "./TeamTab.vue?vue&type=template&id=6f290771&scoped=true&"
import script from "./TeamTab.vue?vue&type=script&lang=js&"
export * from "./TeamTab.vue?vue&type=script&lang=js&"
import style0 from "./TeamTab.vue?vue&type=style&index=0&id=6f290771&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f290771",
  null
  
)

export default component.exports